import React, { Component } from 'react';
import {API} from 'aws-amplify';
import './ec2PaRequiredAttention.css';
import Ec2PaPreviousCommand from './ec2PaPreviousCommand/ec2PaPreviousCommand.js';
import Ec2PaUserInputPanel from './ec2PaUserInputPanel/ec2PaUserInputPanel.js';

class Ec2PaRequiredAttention extends Component {

  state = {
    showPreviousCommands: false,
    previousCommands: [],
    commandsToShow: 10,
    InstanceName: 'fetching...',
    CommandOutput: '',
    showAdditionalInfo: false
  };

  downloaded = false;

  componentDidMount() {

    if (this.props.command.CommandRegion) {
      // console.log({
      //   accountid: this.props.command.AccountId,
      //   instanceid: this.props.command.InstanceIds,
      //   region: this.props.command.CommandRegion
      // });
      API.get('WBU', '/ec2information', {
        queryStringParameters: {
          accountid: this.props.command.AccountId,
          instanceid: this.props.command.InstanceIds,
          region: this.props.command.CommandRegion
        }
      })
      .then(res => {
        this.setState({InstanceName: res.name || 'hello'});
      })
      .catch(err => {
        console.log(err);
      });
    } else {
      this.setState({InstanceName: 'NA'});
    }

  };

  getCommandOutput = () => {

    API.get('WBU', '/commandoutput', {
      queryStringParameters: {
        accountId: this.props.command.AccountId,
        InstanceId: this.props.command.InstanceIds,
        CommandId: this.props.command.CommandId
      }
    })
    .then(res => {
      console.log(res);
      this.setState({CommandOutput: res});
    })
    .catch(err => {
      console.log(err);
    });

  }

  render() {


    const {command, username} = this.props;
    const {
      AccountId,
      CommandComment,
      CommandId,
      CommandRegion,
      CommandStatus,
      DocumentName,
      InstanceIds,
      RequestedDateTime,
      StatusDetails
    } = command;
    const {showPreviousCommands, previousCommands, commandsToShow, InstanceName, CommandOutput} = this.state;

    const daysSince = Math.floor((Date.now() - new Date(RequestedDateTime).getTime()) / (1000 * 60 * 60 * 24));
    const daysSinceString = `${daysSince === 0 ? '<1' : daysSince} day${daysSince > 1 ? 's' : ''} ago`;

    const prevCommandButtonText = !this.downloaded && showPreviousCommands === true ? 'Fetching' :
      !this.downloaded ? 'Fetch' :
        previousCommands.length === 0 ? 'No' :
          showPreviousCommands ? 'Hide' : 'Show';

    return (
      <div className="Ec2PaRequiredAttentionPage">
        <div>
          <p>Requested Date Time: {RequestedDateTime} ({daysSinceString})</p>
          <p>ID: {CommandId}</p>
          <p>Instance Name: {InstanceName}</p>
          <p>Instance ID: {InstanceIds}</p>
          <p>Region: {CommandRegion ? CommandRegion : 'NA'}</p>
          <p>Account ID: {AccountId}</p>
          <p>Command: {DocumentName} - {CommandComment}</p>
          <p>Status: {CommandStatus}{CommandStatus === StatusDetails ? '' : ` - ${StatusDetails}`}</p>
          <p>Output: {CommandOutput === '' && <button onClick={this.getCommandOutput}>Fetch</button>}</p>
          {CommandOutput !== '' && CommandOutput.split('\n').map((line, index) => {return <p key={`${line} + ${index}`}>{line}</p>;})}
          <button onClick={this.showAdditionalInfo}>Additional Info</button>
          {this.state.showAdditionalInfo &&
            <div className="AdditionalInfo">
              <p>{JSON.stringify(command)}</p>
            </div>
          }
          <button onClick={this.previousCommands}>{prevCommandButtonText} Previous Commands</button>
          {showPreviousCommands &&
            <React.Fragment>
                        Commands to show: <input value={this.state.commandsToShow} onChange={this.showMoreCommands}/>
            </React.Fragment>
          }
          {showPreviousCommands && previousCommands.slice(0, commandsToShow).map(command => {
            return <Ec2PaPreviousCommand key={command.CommandId} command={command}/>;
          })}
        </div>
        <Ec2PaUserInputPanel username={username} RequestedDateTime={RequestedDateTime} InstanceIds={InstanceIds}/>
      </div>
    );

  };

  showAdditionalInfo = () => {
    this.setState({showAdditionalInfo: !this.state.showAdditionalInfo});
  }

  showMoreCommands = e => {

    const commandsToShow = e.target.value;

    if (/^\d*$/.test(commandsToShow)) {
      this.setState({commandsToShow});
    }

  }

  previousCommands = () => {

    const {command} = this.props;
    const {CommandComment, InstanceIds, RequestedDateTime} = command;
    const {showPreviousCommands} = this.state;

    if (!this.downloaded) {
      this.setState({showPreviousCommands: !showPreviousCommands});
      API.get('WBU', '/ec2commands', {
        queryStringParameters: {
          action: 'query',
          instancecomment: `${InstanceIds}#${CommandComment}`,
          requesteddatetime: RequestedDateTime
        }
      })
      .then(res => {
        this.downloaded = true;
        this.setState({previousCommands: [...res.Items]});
      })
      .catch(err => {
        console.log(err);
      });
    } else {
      this.setState({showPreviousCommands: !showPreviousCommands});
    }

  }

};


export default Ec2PaRequiredAttention;


// WEBPACK FOOTER //
// ./src/components/content/ec2PatchErrors/ec2PaContent/ec2PaRequiredAttention/ec2PaRequiredAttention.js